export enum UserRule {
  READ = 'read',
  WRITE = 'write',
  DELETE = 'delete',
}
